import React, { useContext, useState } from 'react'
import { Trans, t } from '@lingui/macro'

import { linkBuilder } from 'shared/linkBuilder'
import { navigateTo } from '../../../../app/util/appHistory'
import { ButtonPrimary, ButtonLight } from 'front-end/src/components'
import Message, {
  MessageTypes
} from '../../../../components/common/message/Message'
import { isSurveyEditable } from '../../helpers'

import SurveyQuestions from './SurveyQuestions'
import SurveyQuestionCreateModal from './SurveyQuestionCreateModal'
import '../../Surveys.less'
import IconLock from '../../../../components/common/icon/IconLock'
import IconEye from '../../../../components/common/icon/IconEye'
import { ManageSurveyContext } from '../ManageSurveyContext'
import IconEmptyResources from 'public/assets/img/empty-resources.svg'

export const AddSurveyQuestionButtonWithModal: React.FC = () => {
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false)
  const { survey, questions } = useContext(ManageSurveyContext)

  return (
    <>
      <div className="Survey__addQuestion">
        <ButtonPrimary
          size="md"
          disabled={!isSurveyEditable(survey)}
          onClick={() => {
            setShowCreateModal(true)
          }}
        >
          + <Trans>Add {questions.length > 0 ? t`another` : ''} question</Trans>
        </ButtonPrimary>
      </div>

      <SurveyQuestionCreateModal
        isShown={showCreateModal}
        hide={() => {
          setShowCreateModal(false)
        }}
        onCreate={() => setShowCreateModal(false)}
      />
    </>
  )
}

export const SurveysCreate = () => {
  const { survey, questions } = useContext(ManageSurveyContext)

  return (
    <div className="Survey__content">
      {questions.length > 0 && (
        <div className="Survey__preview">
          <ButtonLight
            onClick={() => navigateTo(linkBuilder.surveyPreview(survey.id))}
            leftIcon={<IconEye />}
          >
            <Trans>Preview survey</Trans>
          </ButtonLight>
        </div>
      )}

      {survey.published_at && (
        <Message className="Message__lockedIcon" type={MessageTypes.WARNING}>
          <div className="Icon__wrapper">
            <IconLock />
          </div>
          <div className="Text_wrapper">
            <Trans>
              This survey has been locked, and cannot be edited anymore.
            </Trans>
          </div>
        </Message>
      )}

      {questions.length <= 0 && (
        <div className="no-items">
          <img src={IconEmptyResources} alt={t`Empty resources`} />
          <h3>
            <Trans>No questions found</Trans>
          </h3>
        </div>
      )}

      <SurveyQuestions />
      {!survey.published_at && !survey.completed_at && (
        <AddSurveyQuestionButtonWithModal />
      )}
    </div>
  )
}
